<template>
  <v-dialog v-model="dialog" max-width="400px" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon color="error" class="mr-2">mdi-alert</v-icon>
        Confirmar Exclusão
      </v-card-title>

      <v-card-text>
        <p class="mb-0">
          Tem certeza de que deseja excluir o webhook
          <strong>"{{ item ? item.nome : '' }}"</strong>?
        </p>
        <p class="text--secondary mt-2 mb-0">
          Esta ação não pode ser desfeita.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="cancel"
          :disabled="loading"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="error"
          @click="confirm"
          :loading="loading"
        >
          Excluir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel')
    },
    
    confirm() {
      this.$emit('confirm', this.item)
    }
  }
}
</script>

<style scoped>
.headline {
  display: flex;
  align-items: center;
}
</style>